<!-- Loading -->
<div *ngIf="loading" class="flex justify-content-center p-3">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4"></p-progressSpinner>
</div>

<!-- Estado vazio -->
<div *ngIf="!loading && variantes.length === 0 && !novaVariante" class="text-center p-3">
  <small class="text-500">{{ texts.nenhuma }}</small>
</div>

<!-- Lista de variantes com drag & drop -->
<div *ngIf="!loading && variantes.length > 0"
     cdkDropList
     (cdkDropListDropped)="onDrop($event)"
     class="flex flex-column gap-2">

  <div *ngFor="let variante of variantes; trackBy: trackById"
       cdkDrag
       class="variante-item surface-50 border-round-lg overflow-hidden">

    <!-- Linha resumo -->
    <div class="flex align-items-center gap-2 p-2">
      <div class="drag-handle-sm" cdkDragHandle aria-label="Arrastar para reordenar">
        <i class="pi pi-ellipsis-v"></i>
        <i class="pi pi-ellipsis-v"></i>
      </div>

      <span class="flex-1 font-medium text-sm text-900 white-space-nowrap overflow-hidden text-overflow-ellipsis">
        {{ variante.nome }}
      </span>

      <!-- Preco promocional (riscado) -->
      <span *ngIf="variante.precoPromocional" class="text-sm line-through text-400 mr-1">
        {{ moedaSimbolo }} {{ variante.preco | number:'1.2-2':moedaLocal }}
      </span>
      <span class="text-sm font-bold text-primary white-space-nowrap">
        {{ moedaSimbolo }} {{ (variante.precoPromocional || variante.preco) | number:'1.2-2':moedaLocal }}
      </span>

      <!-- Toggle ativo -->
      <p-inputSwitch [(ngModel)]="variante.ativo"
                     (onChange)="onToggleAtivo(variante)"
                     [pTooltip]="variante.ativo ? texts.disponivel : texts.indisponivel">
      </p-inputSwitch>

      <!-- Expandir/colapsar -->
      <button pButton type="button"
              [icon]="varianteExpandida === variante.id ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
              class="p-button-rounded p-button-text p-button-sm"
              [pTooltip]="varianteExpandida === variante.id ? texts.recolher : texts.expandir"
              (click)="toggleExpandir(variante.id)">
      </button>
    </div>

    <!-- Detalhes expandidos -->
    <div *ngIf="varianteExpandida === variante.id" class="p-3 pt-0 border-top-1 surface-border">
      <div class="grid mt-2">
        <div class="col-6">
          <label class="font-bold text-xs text-700 mb-1 block">{{ texts.nome }}</label>
          <input pInputText [(ngModel)]="variante.nome" class="w-full text-sm" />
        </div>
        <div class="col-6">
          <label class="font-bold text-xs text-700 mb-1 block">{{ texts.preco }}</label>
          <p-inputNumber [(ngModel)]="variante.preco" mode="decimal"
                         [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                         [minFractionDigits]="2" [maxFractionDigits]="2"
                         styleClass="w-full" inputStyleClass="border-round-lg text-sm">
          </p-inputNumber>
        </div>
        <div class="col-6">
          <label class="font-bold text-xs text-700 mb-1 block">{{ texts.preco_promocional }}</label>
          <p-inputNumber [(ngModel)]="variante.precoPromocional" mode="decimal"
                         [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                         [minFractionDigits]="2" [maxFractionDigits]="2"
                         styleClass="w-full" inputStyleClass="border-round-lg text-sm">
          </p-inputNumber>
        </div>
        <div class="col-6">
          <label class="font-bold text-xs text-700 mb-1 block">{{ texts.custo }}</label>
          <p-inputNumber [(ngModel)]="variante.custo" mode="decimal"
                         [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                         [minFractionDigits]="2" [maxFractionDigits]="2"
                         styleClass="w-full" inputStyleClass="border-round-lg text-sm">
          </p-inputNumber>
        </div>
        <div class="col-6">
          <label class="font-bold text-xs text-700 mb-1 block">{{ texts.desconto }}</label>
          <p-inputNumber [(ngModel)]="variante.desconto" mode="decimal"
                         suffix="%" [min]="0" [max]="100"
                         [minFractionDigits]="0" [maxFractionDigits]="2"
                         styleClass="w-full" inputStyleClass="border-round-lg text-sm">
          </p-inputNumber>
        </div>
        <div class="col-6">
          <label class="font-bold text-xs text-700 mb-1 block">{{ texts.sku }}</label>
          <input pInputText [(ngModel)]="variante.sku" class="w-full text-sm" />
        </div>
      </div>

      <div class="flex justify-content-between mt-3">
        <button pButton type="button" [label]="texts.excluir" icon="pi pi-trash"
                class="p-button-danger p-button-text p-button-sm"
                (click)="onRemover(variante.id)">
        </button>
        <button pButton type="button" [label]="texts.salvar" icon="pi pi-check"
                class="p-button-sm btn-primary"
                (click)="salvarEdicao(variante)">
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Formulario nova variante -->
<div *ngIf="novaVariante" class="p-3 surface-50 border-round-lg mt-2">
  <div class="grid">
    <div class="col-6">
      <label class="font-bold text-xs text-700 mb-1 block">{{ texts.nome }}</label>
      <input pInputText [(ngModel)]="novaVariante.nome" class="w-full text-sm" />
    </div>
    <div class="col-6">
      <label class="font-bold text-xs text-700 mb-1 block">{{ texts.preco }}</label>
      <p-inputNumber [(ngModel)]="novaVariante.preco" mode="decimal"
                     [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                     [minFractionDigits]="2" [maxFractionDigits]="2"
                     styleClass="w-full" inputStyleClass="border-round-lg text-sm">
      </p-inputNumber>
    </div>
    <div class="col-6">
      <label class="font-bold text-xs text-700 mb-1 block">{{ texts.preco_promocional }}</label>
      <p-inputNumber [(ngModel)]="novaVariante.precoPromocional" mode="decimal"
                     [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                     [minFractionDigits]="2" [maxFractionDigits]="2"
                     styleClass="w-full" inputStyleClass="border-round-lg text-sm">
      </p-inputNumber>
    </div>
    <div class="col-6">
      <label class="font-bold text-xs text-700 mb-1 block">{{ texts.custo }}</label>
      <p-inputNumber [(ngModel)]="novaVariante.custo" mode="decimal"
                     [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                     [minFractionDigits]="2" [maxFractionDigits]="2"
                     styleClass="w-full" inputStyleClass="border-round-lg text-sm">
      </p-inputNumber>
    </div>
    <div class="col-6">
      <label class="font-bold text-xs text-700 mb-1 block">{{ texts.desconto }}</label>
      <p-inputNumber [(ngModel)]="novaVariante.desconto" mode="decimal"
                     suffix="%" [min]="0" [max]="100"
                     [minFractionDigits]="0" [maxFractionDigits]="2"
                     styleClass="w-full" inputStyleClass="border-round-lg text-sm">
      </p-inputNumber>
    </div>
    <div class="col-6">
      <label class="font-bold text-xs text-700 mb-1 block">{{ texts.sku }}</label>
      <input pInputText [(ngModel)]="novaVariante.sku" class="w-full text-sm" />
    </div>
  </div>

  <div class="flex justify-content-end gap-2 mt-3">
    <button pButton type="button" [label]="texts.cancelar"
            class="p-button-text p-button-sm"
            (click)="cancelarNovaVariante()">
    </button>
    <button pButton type="button" [label]="texts.salvar" icon="pi pi-check"
            class="p-button-sm btn-primary"
            [disabled]="!novaVariante.nome?.trim()"
            (click)="salvarNovaVariante()">
    </button>
  </div>
</div>

<!-- Botao adicionar -->
<button *ngIf="!novaVariante && !loading" pButton type="button"
        [label]="texts.adicionar"
        icon="pi pi-plus"
        class="p-button-text p-button-sm mt-2"
        (click)="iniciarNovaVariante()">
</button>
